import calendarIcon from '@assets/icons/ai-chat/calendar.svg';

import { useTranslation } from 'react-i18next';

export const dateAiChatFormClass =
    'mb-0! w-full [&>label]:mb-0! [&>label]:w-full! [&>label]:border-b [&>label]:border-solid [&>label]:border-(--color-card-text)/10 [&>label]:px-[18px] [&>label]:py-4 [&>label]:text-sm! [&>label]:leading-5! [&>.serviceFormMessage]:mx-[18px] [&>.serviceFormMessage]:mb-3';
export const dateAiChatControlClass =
    'mx-[18px]! my-3! h-12! min-h-12! w-[calc(100%-36px)]! rounded-xl! border-0! bg-(--color-ai-file-upload-bg)! pl-4! pr-2! py-2! text-sm! font-medium! focus-within:outline-2! focus-within:outline-solid! focus-within:outline-(--color-brand-green)! data-[error=true]:outline-1! data-[error=true]:outline-solid! data-[error=true]:outline-(--color-danger)!';
export const dateAiChatInputClass =
    'h-8! min-h-8! rounded-none! border-0! bg-transparent! p-0! font-medium! [&>input]:placeholder:text-(--color-neutral-6)!';

export function DateAiChatLabel({ children }: React.PropsWithChildren) {
    return (
        <span className='text-sm leading-5 font-medium text-(--color-card-text)'>
            {children}
        </span>
    );
}

export function DateAiChatCalendarButton({
    open,
    disabled,
}: {
    open: () => void;
    disabled?: boolean;
}) {
    const { t } = useTranslation();
    return (
        <button
            type='button'
            aria-label={t('translation:selectDate')}
            disabled={disabled}
            className='relative flex size-7 shrink-0 cursor-pointer items-center justify-center rounded-[7px] border border-solid border-(--color-card-text)/10 bg-(--color-card) [box-shadow:0_0_4.412px_0.882px_rgba(0,0,0,0.05)] before:absolute before:-inset-2 focus-visible:outline-2 focus-visible:outline-(--color-brand-green) disabled:cursor-default disabled:opacity-50 dark:[&_img]:invert'
            onMouseDown={(event) => event.preventDefault()}
            onClick={(event) => {
                event.stopPropagation();
                open();
            }}
        >
            <img src={calendarIcon} alt='' aria-hidden />
        </button>
    );
}
